import { render, staticRenderFns } from "./Stations.vue?vue&type=template&id=83a64fa2&"
import script from "./Stations.vue?vue&type=script&lang=js&"
export * from "./Stations.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports